module.exports = __webpack_public_path__ + "88149cdd6cd8bfc2a24045e7d9ac084b.png";